module.exports = __webpack_public_path__ + "static/img/m6.d607f91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-neo/mobile/m6.png
// module id = h9Bt
// module chunks = 12